"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.USER_COMPANY_ACCOUNT_ENDPOINT = {
    getCompanyDetail: '/user-company/{{version}}/companies/{{companyUuid}}',
    putPricingData: '/backoffice/user-company/{{version}}/companies/{{companyUuid}}/rh-markup',
    patchUserDetail: '/backoffice/user-company/{{version}}/users/{{userUuid}}',
    createCompany: '/user-company/{{version}}/companies',
    getCheckCompanyEmail: '/user-company/{{version}}/companies/check-email?email={{companyEmail}}{{$randomInt}}',
    putUpdateCompany: '/user-company/{{version}}/companies/{{companyUuid}}',
    postCreateCompanyLinkedToAccount: '/user-company/{{version}}/companies/link/{{idpUuid}}',
    getCompanyPreRegister: '/user-company/{{version}}/companies/company-creation?{{query}}',
    getUbeeqoTitles: '/user-company/{{version}}/users/titles?{{query}}',
    postCheckCompanyEmails: '/user-company/{{version}}/companies/{{companyUuid}}/check-emails-for-driving',
};
